import { Select } from '@bepro-travel/fe.ui';
import { TourPackageDeal } from '../interfaces/OphirResponse';

export interface FilterRating {
  number: number;
  checked: boolean;
  price: number;
  currency: string;
}

export interface FilterNights {
  count: number;
  checked: boolean;
  price: number;
  currency: string;
}

export interface FilterPackage {
  name: string;
  checked: boolean;
  price: number;
  currency: string;
}

export class OphirFilterModel {
  hotels: Select[];
  selectedHotel: string;
  prices: {
    min: number;
    max: number;
    value: [number, number];
  };
  nights: FilterNights[];
  packages: FilterPackage[];

  countries: Select[];
  selectedCountries: string[];
  months: Select[];
  selectedMonths: string[];

  constructor(packages: TourPackageDeal[], countries?: Select[], months?: Select[]) {
    this.hotels = packages
      .map((item) => item.hotelName)
      .filter((item, index, array) => array.indexOf(item) === index)
      .sort()
      .map((item) => ({ value: item, label: item }));
    this.selectedHotel = '';

    this.nights = packages
      .map((item) => ({
        count: item.nightsCount,
        checked: false,
        price: 0,
        currency: '',
      }))
      .filter(
        (item, index, array) => array.findIndex((element) => element.count === item.count) === index
      )
      .sort((a, b) => a.count - b.count);
    this.nights.forEach((item) => {
      const prices = packages
        .filter((element) => element.nightsCount === item.count)
        .map((element) => element.price.onePersonPrice);
      item.price = Math.min(...prices);
      item.currency = packages.find(
        (el) => el.price.onePersonPrice === item.price
      )!.price.currencySymbol;
    });

    this.packages = packages
      .map((item) => ({
        name: item.boardDescription,
        checked: false,
        price: item.price.onePersonPrice,
        currency: '',
      }))
      .filter(
        (item, index, array) => array.findIndex((element) => element.name === item.name) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name));
    this.packages.forEach((item) => {
      const prices = packages
        .filter((element) => element.boardDescription === item.name)
        .map((element) => element.price.onePersonPrice);
      item.price = Math.min(...prices);
      item.currency = packages.find(
        (el) => el.price.onePersonPrice === item.price
      )!.price.currencySymbol;
    });

    const prices = packages.map((item) => item.price.onePersonPrice);
    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices) + 1;

    this.prices = {
      min: minPrice,
      max: maxPrice,
      value: [minPrice, maxPrice],
    };
    this.countries = countries?.filter((m) => m.value !== 'all') || [];
    this.selectedCountries = [];
    this.months = months?.filter((m) => m.value !== 'all') || [];
    this.selectedMonths = [];
  }
}
